import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { lowerCase, upperFirst } from 'lodash';
import CopyText from 'src/components/common/CopyText';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';
import { getStringOrDefault } from 'src/utils/helpers/stringHelpers';

const QuickViewPanel = ({ selected }: { selected?: TypeSingleHSCodePrediction }) => {
  const {
    palette: { common, divider },
    shape: { borderRadius },
  } = useTheme();
  const chapterName = getStringOrDefault(selected?.detail_description?.chapter?.chapter_name);
  const chapterDescription = getStringOrDefault(selected?.detail_description?.chapter?.description);
  const headingName = getStringOrDefault(selected?.detail_description?.heading?.heading_name);
  const headingDescription = getStringOrDefault(selected?.detail_description?.heading?.description);
  const subHeadingName = getStringOrDefault(selected?.detail_description?.subheading?.subheading_name);
  const subHeadingDescription = getStringOrDefault(selected?.detail_description?.subheading?.description);

  return (
    <Box>
      <Box
        textAlign={'center'}
        p={2}
        sx={{
          background: 'linear-gradient(180deg, #7551FF 0%, #3311DB 100%)',
        }}
        borderRadius={`${borderRadius * 2}px ${borderRadius * 2}px 0px 0px`}
      >
        <Typography variant="subtitle1" color={common.white}>
          Quick View Panel
        </Typography>
      </Box>
      <WhiteBoxContent padding={2}>
        <Stack alignItems={'stretch'} direction={'row'} justifyContent={'space-between'}>
          <Typography color={'secondary.main'} variant="subtitle1">
            {selected?.hs_code}
            <CopyText text={selected?.hs_code} />
          </Typography>

          <Box flex={1} />
        </Stack>
        <Typography mt={1} color={'text.secondary'} variant="body2">
          {selected?.description}
        </Typography>
        <Divider sx={{ my: 2 }} />

        {selected?.detail_description?.chapter && (
          <Box pl={2} borderLeft={'1px solid' + divider}>
            <Typography display={'inline'} color={'secondary.main'} variant="subtitle1">
              {upperFirst(lowerCase(chapterName))}:{' '}
              <Typography display={'inline'} variant="body2" color={'text.secondary'}>
                {upperFirst(lowerCase(chapterDescription))}
              </Typography>
            </Typography>

            {selected?.detail_description?.heading && (
              <Box mt={2} pl={2} borderLeft={'1px solid' + divider}>
                <Typography display={'inline'} color={'secondary.main'} variant="subtitle1">
                  {upperFirst(lowerCase(headingName))}:{' '}
                  <Typography display={'inline'} variant="body2" color={'text.secondary'}>
                    {upperFirst(lowerCase(headingDescription))}
                  </Typography>
                </Typography>

                {selected?.detail_description?.subheading && (
                  <Box mt={2} pl={2} borderLeft={'1px solid' + divider}>
                    <Typography display={'inline'} color={'secondary.main'} variant="subtitle1">
                      {upperFirst(lowerCase(subHeadingName))}:{' '}
                      <Typography display={'inline'} variant="body2" color={'text.secondary'}>
                        {upperFirst(lowerCase(subHeadingDescription))}
                      </Typography>
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        )}
      </WhiteBoxContent>
    </Box>
  );
};
export default QuickViewPanel;
